import { twMerge } from 'tailwind-merge';
import { findByValue } from '@witmetrics/utils/arrays';
import type { ArchShape, UpperArchSettings } from '@witmetrics/unison-core';
import SelectDropdown from '@/components/inputs/SelectDropdown';
import { ToggleOption } from '@/components/ToggleBlock';
import Slider from '@/components/Slider';
import { CheckBoxIcon, UncheckBoxIcon } from '@/icons';
import ExposureControl from '../ExposureControl';
import type { FaceFilterSettings } from '../../types';
import { TOOTH_DESIGN_OPTIONS } from './constants';
import { classes } from './utils';

export type VeneerControlsProps = {
  archSettings: UpperArchSettings;
  opacity: number;
  filter: FaceFilterSettings;
  onChange: (archSettings: UpperArchSettings) => void;
  onUpdateFilter: (filter: FaceFilterSettings) => void;
  onUpdateOpacity: (opacity: number) => void;
};

export default function VeneerControls({
  archSettings,
  opacity,
  filter,
  onChange,
  onUpdateFilter,
  onUpdateOpacity,
}: VeneerControlsProps) {
  return (
    <div className={classes.wrapper}>
      <SelectDropdown
        className={classes.toothDesign}
        value={findByValue(TOOTH_DESIGN_OPTIONS, archSettings.toothDesign)}
        options={TOOTH_DESIGN_OPTIONS}
        onChange={(update) =>
          onChange({ ...archSettings, toothDesign: update.value })
        }
      />
      <ToggleOption
        selected={archSettings.embrasures}
        value={true}
        onChange={() =>
          onChange({ ...archSettings, embrasures: !archSettings.embrasures })
        }>
        {archSettings.embrasures ? <CheckBoxIcon /> : <UncheckBoxIcon />}
        <span className={classes.toggleLabel}>Embrasures</span>
      </ToggleOption>
      <ExposureControl filter={filter} onUpdate={onUpdateFilter} />
      <div className={twMerge(classes.sliderWrapper, classes.archWrapper)}>
        <Slider
          marks
          className={classes.slider}
          max={6}
          min={1}
          thumbSize={20}
          value={archSettings.archShape}
          onChange={(update) =>
            onChange({ ...archSettings, archShape: update as ArchShape })
          }
        />
        <label className={classes.sliderLabel}>Arch</label>
      </div>
      <div className={twMerge(classes.sliderWrapper, classes.compareWrapper)}>
        <Slider
          className={classes.slider}
          thumbSize={20}
          max={100}
          min={0}
          value={opacity}
          onChange={onUpdateOpacity}
        />
        <label className={classes.sliderLabel}>Compare</label>
      </div>
    </div>
  );
}
